module.exports = __webpack_public_path__ + "assets/9edf52721e4ba9e43331a9bc36a5c98f.mp3";